import { Kbd } from "@dfws/ui";
import { SHORTCUTS, type ShortcutDef } from "../../command/shortcuts";
import { updateSettings, useSettings } from "../../settings/store";
import { Row } from "./parts";
import s from "./Settings.module.css";

export function KeyboardSection() {
  const st = useSettings();
  return (
    <>
      <Row label="Keyboard shortcuts" hint="Single-key shortcuts such as j, k and g then i. Ctrl+K always works.">
        <input type="checkbox" role="switch" className={s.switch} checked={st.shortcutsEnabled} onChange={(e) => updateSettings({ shortcutsEnabled: e.target.checked })} aria-label="Keyboard shortcuts" />
      </Row>
      <ul className={s.list} style={{ marginTop: "var(--space-6)" }}>
        {(Object.values(SHORTCUTS) as ShortcutDef[]).map((d) => (
          <li key={d.keys} className={s.listItem}>
            <div className={s.listMain}><div className={s.listTitle}>{d.label}</div><div className={s.listSub}>{d.group}</div></div>
            <span style={{ display: "flex", gap: 4 }}>{d.display.map((k, i) => <Kbd key={k + i}>{k}</Kbd>)}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
